import { aggregate } from '@directus/sdk';
import { useQuery } from '@tanstack/react-query';

import { directusClient } from '../../services/directusClient/directusClient.ts';
import { usePromoterItemQuery } from '../promoter/usePromoterItemQuery.ts';

export const useIncompleteEventsCountQuery = () => {
  const { data } = usePromoterItemQuery();

  return useQuery({
    queryKey: ['incomplete_events', 'count', { promoterId: data?.id }],
    queryFn: async () => {
      const result = await directusClient.request(
        aggregate('incomplete_events', {
          aggregate: { count: '*' },
          query: {
            filter: { promoter: { _eq: data?.id } },
          },
        }),
      );

      return Number(result[0]?.count ?? 0);
    },
    enabled: !!data?.id,
  });
};
